import { Controller, type Control } from 'react-hook-form';
import { ToggleButtonGroup } from '../../Input';
import { ErrorText } from '@buoyhealth/common.buoy-input';
import Alert from '../../Alert';

const TOGGLE_OPTIONS_ALARM = [
  {
    label: 'I understand the risks and wish to continue with a doctor review.',
    value: true,
  },
];

const DoctorConfirmationAlarmDisclaimer = ({ control }: { control: Control<any, any> }) => {
  return (
    <>
      <div className="bp-font-primary-main bp-inline-flex bp-flex-col bp-items-start bp-justify-start bp-gap-3 bp-text-gray-100">
        <Alert
          show
          message={
            <>
              <div className="bp-font-bold">Warning: Alarming Scenario Detected</div>
              <div className="bp-mt-1">
                Your answers indicate a serious, potentially life-threatening condition.
              </div>
            </>
          }
          severity="error"
          className="bp-w-full"
        />
        <p className="bp-mt-2">
          This doctor review is intended for non-emergency situations as it will take up to one
          business day to receive a response.
        </p>
        <p>
          If you have any concerns about your condition being an emergency, please call 911 or go to
          your nearest hospital emergency room.
        </p>
        <p>You may continue if you agree with the statement below.</p>
        <div className="bp-mt-2">
          <Controller
            control={control}
            name="alarmDisclaimer"
            render={({ field, fieldState }) => {
              const { ref: inputRef, ...fieldProps } = field;
              return (
                <>
                  <ToggleButtonGroup
                    {...fieldProps}
                    options={TOGGLE_OPTIONS_ALARM}
                    onChange={(_event, value) => {
                      field.onChange(!!value.length);
                    }}
                    multiSelect
                    value={[Boolean(field.value)]}
                    hasError={!!fieldState.error}
                  />
                  <ErrorText show={!!fieldState.error} message="You must agree to continue." />
                </>
              );
            }}
            rules={{
              required: true,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DoctorConfirmationAlarmDisclaimer;
